import toastr from "toastr"
import "./toast.css"

const toast = (
  type = "",
  message = "",
  title = "",
  options = {
    positionClass: "toast-top-right",
    timeOut: 5000,
    extendedTimeOut: 1000,
    closeButton: false,
    debug: false,
    progressBar: false,
    preventDuplicates: false,
    newestOnTop: false,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    showDuration: 300,
    hideDuration: 1000,
    enableHtml: true,
    allowHtml: true,
  }
) => {
  toastr.options = options
  switch (type) {
    case "info":
      toastr.info(message, title)
      break
    case "warning":
      toastr.warning(message, title)
      break
    case "error":
      toastr.error(message, title)
      break
    case "success":
      toastr.success(message, title)
      break
    default:
      toastr.success(message, title)
      break
  }
}

export default toast
